import BaseApi from '@/api/controller/base';

const USER_API_URL = 'user/';

class UserApi extends BaseApi {
  constructor() {
    super(USER_API_URL);
  }

  async get(id) {
    return this.api.get(`${id}`);
  }

  async create(user) {
    return this.api.post('', user);
  }

  async update(user) {
    const userId = user.id;
    if (userId !== undefined && userId !== null) {
      return this.api.post(`${userId}`, user);
    }
    return Promise.error('No user id provided.');
  }

  async fetchByUsername(username) {
    return this.request(this.api.get('fetchByUsername', {
      params: {
        username,
      },
    }));
  }

  async updatePassword(user, password) {
    const userId = user.id;
    if (userId !== undefined && userId !== null) {
      return this.api.post(`${userId}/updatePassword`, {
        password,
      });
    }
    return Promise.error('No user id provided.');
  }

  async updateAllowedOffices(user, allowedOffices) {
    const userId = user.id;
    if (userId !== undefined && userId !== null) {
      return this.api.post(`${userId}/updateAllowedOffices`, {
        allowedOffices,
      });
    }
    return Promise.error('No user id provided.');
  }

  async current() {
    return this.api.get('current');
  }

  async authenticate(credentials) {
    return this.api.post('authenticate', credentials);
  }

  async authenticateWithRefreshToken(refreshToken) {
    return this.api.post('authenticate/refresh-token', refreshToken);
  }

  async getGridData(params) {
    return this.api.post('gridData', params);
  }
}

const apiInstance = new UserApi();
export { UserApi, apiInstance };
export default apiInstance;
